export class schoolStatisticsData{
result1:string="";
result2:string="";
result3:string="";
result4:string="";
result5:string="";
result6:string="";
}
